/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc service
 * @name userCache
 *
 * @description
 * A cache factory for users settings.
 */
angular.module('BCP')
  .factory('userCache', ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('user-cache');
  }]);

})();
